import React from 'react'

import * as S from './styles'

/**
 * @typedef {Object} RadioProps
 * @property {string | React.ReactNode} label
 * @property {boolean} checked
 * @property {(event: React.ChangeEvent<HTMLInputElement>) => void} onChange
 * @property {string | number} value
 */

/**
 * @param {RadioProps} props
 */
export default function Radio({ label, checked, onChange, value }) {
  return (
    <S.Radio
      size="sm"
      variant="outline"
      label={label}
      value={value}
      checked={checked}
      onChange={onChange}
    />
  )
}
